import React, { useEffect, useState } from "react";
import { render } from "react-dom";

// Import Highcharts
import Highcharts from "highcharts";
import HCMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import HighchartsReact from "highcharts-react-official";

HCMore(Highcharts);
solidGauge(Highcharts);

const BarLineCharts = (props) => {
  const [options, setOptions] = useState({});

  useEffect(() => {
    setOptions({
      title: {
        text: "",
      },
      chart: {
        backgroundColor: "#2bb4b0",
        marginBottom: 100,
      },
      credits: {
        enabled: false,
      },

      exporting: {
        enabled: false,
      },
      xAxis: {
        categories: [
          "Years Experience",
          "Qualifications",
          "Courses",
          "Competency",
          "Skills",
        ],
        labels: {
          enabled: false,
        },
        plotLines: [],
        // plotBands: [
        //   {
        //     // mark the weekend
        //     color: "#73b7b4",
        //     from: 1,
        //     to: 2,
        //   },
        //   {
        //     // mark the weekend
        //     color: "#73b7b4",
        //     from: 3,
        //     to: 4,
        //   },
        //   {
        //     // mark the weekend
        //     color: "#73b7b4",
        //     from: 5,
        //     to: 6,
        //   },
        //   {
        //     // mark the weekend
        //     color: "#73b7b4",
        //     from: 7,
        //     to: 8,
        //   },
        //   {
        //     // mark the weekend
        //     color: "#73b7b4",
        //     from: 9,
        //     to: 10,
        //   },
        // ],
      },
      yAxis: {
        title: "",
        gridLineWidth: 0,
        labels: {
          enabled: false,
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        series: {
          marker: {
            fillColor: "#e73f26",
            lineWidth: 2,
            lineColor: "#e73f26", // inherit from series
          },
        },
      },

      series: [
        {
          name: "Score",
          type: "column",
          data: props.data,
          color: "#73b7b4",
        },
        {
          name: "Score",
          type: "line",
          data: props.data,
          color: "white",
        },
      ],
    });
  }, [props]);

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      containerProps={{ className: "equal-height-graph" }}
    />
  );
};

export default BarLineCharts;
